import "../../../styles/fontSizes.scss";
import palette from "../../../styles/palette.scss";
import CapsuleButton from "../../atoms/capsuleButton/capsuleButton";
import Tag from "../../atoms/tag/tag";
import Text from "../../atoms/text/text";
import "./description.scss";

import { useNavigate } from "react-router-dom";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
//colors = [palette.brown, palette.green, palette.darkBrown, palette.darkGreen, palette.brown, palette.green, palette.darkBrown, palette.darkGreen]
//Menu | Botones del menu | Text
const Description = ({
  isOnCalendar,
  isOnFocus,
  className,
  bgColor,
  color,
  textSize,
  rotation,
  data,
}) => {
  const navigate = useNavigate();
  const dataCalendar = [
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
    {
      date: "2022-04-20",
      title: "Evento de sede",
      events: ["Cierrre", "evento deportivo"],
      imgURL:
        "https://c4.wallpaperflare.com/wallpaper/867/119/831/arbol-naturaleza-roble-viejo-wallpaper-preview.jpg",
    },
  ];
  const meses = [
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  return (
    <>
      <div
        style={{
          transform: `rotateZ(${rotation}Deg)`,
          backgroundColor: bgColor,
        }}
        className={`${className} ${
          isOnFocus
            ? isOnCalendar
              ? "description__container--focus-1"
              : "description__container--focus-2"
            : "description__container--normal"
        } description__container font-size--${textSize}`}
      >
        {isOnFocus ? (
          isOnCalendar ? (
            <>
              <div className="description__date-container">
                {data.date && (
                  <>
                    <Text
                      className={"description__text-anim--appear"}
                      color={color}
                      type="h"
                      textSize={5}
                    >
                      {new Date(data.date).getDate()}
                    </Text>
                    <Text
                      className={"description__text-anim--appear"}
                      color={color}
                      type="p"
                      textSize={2}
                    >{`de ${
                      meses[new Date(data.date).getMonth()]
                    } del ${new Date(data.date).getFullYear()}`}</Text>
                  </>
                )}
              </div>
              <div>
                {data.title && (
                  <Text
                    className={"description__text-anim--appear"}
                    color={palette.black}
                    type="h"
                    textSize={3}
                  >
                    {data.title}
                  </Text>
                )}
                <ul>
                  {data.events.map((event, index) => (
                    <li key={index}>
                      {
                        <Text
                          className={"description__text-anim--appear"}
                          color={palette.black}
                          type="p"
                          textSize={2}
                        >
                          {event}
                        </Text>
                      }
                    </li>
                  ))}
                </ul>
                <br />
                <CapsuleButton
                  handle={() => navigate(`/calendario`)}
                  color={palette.white}
                  bgColor={palette.darkBrown}
                  className={"description__text-anim--appear"}
                >
                  {"Ver todos los eventos"}
                </CapsuleButton>
              </div>
            </>
          ) : (
            <>
              <div>
                {data.title && (
                  <Text
                    className={"description__text-anim--appear"}
                    color={color}
                    type="h"
                    textSize={3}
                  >
                    {data.title}
                  </Text>
                )}
                {data.tag && (
                  <Tag
                    className={"description__text-anim--appear"}
                    type={data.tag}
                    textSize={1}
                  />
                )}
              </div>
              {data.description && (
                <Text
                  className={"description__text-anim--appear"}
                  color={color}
                  type="p"
                  textSize={1}
                >
                  {data.description}
                </Text>
              )}
              {data.buttonText1 && data.handle1 && (
                <CapsuleButton
                  handle={data.handle1}
                  color={palette.white}
                  bgColor={palette.darkBrown}
                  className={"description__text-anim--appear"}
                >
                  {data.buttonText1}
                </CapsuleButton>
              )}
              {data.buttonText2 && data.handle2 && (
                <CapsuleButton
                  handle={data.handle2}
                  color={palette.white}
                  bgColor={palette.darkBrown}
                  className={"description__text-anim--appear"}
                >
                  {data.buttonText2}
                </CapsuleButton>
              )}
            </>
          )
        ) : data.imgURL ? (
          <img
            className="description__img"
            src={data.imgURL}
            alt="Imagen ilustrativa del contenido"
          />
        ) : (
          data.resumeTitle && (
            <Text color={color} type="h" textSize={2}>
              {data.resumeTitle}
            </Text>
          )
        )}
      </div>
    </>
  );
};

export default Description;
